import {createSlice} from "@reduxjs/toolkit";

export type LocalDataPayload<T> = {key: string; value: T};

const initialState = {data: {} as Record<string, any>};

const sliceStore = createSlice({
	name: "localStore",
	initialState,
	reducers: {
		setData: (state, action: {payload: LocalDataPayload<any>}) => {
			const {payload} = action;
			state.data[payload.key] = payload.value;
		},
		initData: () => initialState,
	},
});

export const {setData, initData} = sliceStore.actions;
export default sliceStore.reducer;
